import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import '../common.css';
import LoadingBar from 'react-top-loading-bar'
import Loading from '../Loading'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContext } from "../../helpers/AuthContext";


const UserList = () => {

  const { authState } = useContext(AuthContext);

  const [people, setPeople] = useState([]);
  const [entityIdList, setEntityIdList] = useState([]);

  const [allGoodsListName, setAllGoodsListName] = useState([]);
  const [allVendorsName, setAllVendorsName] = useState([]);
  const [allOnwersname, setAllOnwersname] = useState([]);
  const [allDriversName, setAllDriversName] = useState([]);

  const [vehicle_no, setVehicleNo] = useState('');
  const [model, setModel] = useState('');
  const [capacity, setCapacity] = useState('');
  const [regions, setRegions] = useState('');
  const [owner_name, setOwnerName] = useState('');
  const [vendor_name, setVendorName] = useState('');
  const [driver_name, setDriverName] = useState('');
  const [goods_types, setGoodsTypes] = useState('');
  const [vehicle_id_doc, setVehicleIdDoc] = useState('');
  const [vehicle_id_doc_no, setVehicleIdDocNo] = useState('');
  const [vehicle_id_doc_validity, setVehicleIdDocValidity] = useState('');

  const [disableUpdate, setDisableUpdate] = useState(false);
  const [disableAdd, setDisableAdd] = useState(false);

  const [editIndex, setEditIndex] = useState(null);

  const [showAdd, setShowAdd] = useState(false);

  const [showFindSearch, setShowFindSearch] = useState(false);

  const [columnOrder, setColumnOrder] = useState([['vehicle_no', 'text'], ['model', 'text'], ['capacity', 'text'], ['regions', 'text'], ['owner_name', 'select'], ['vendor_name', 'select'], ['driver_name', 'select'], ['goods_types', 'select'], ['vehicle_id_doc', 'select'], ['vehicle_id_doc_no', 'text'], ['vehicle_id_doc_validity', 'date']]);

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable) {
        return;
      }
      switch (event.key) {
        case 'F2':
          event.preventDefault();
          showOneHideAll();
          setShowAdd(showAdd ? false : true);
          setDisableUpdate(showAdd ? false : true);
          break;
        case 'F3':
          event.preventDefault();
          showOneHideAll();
          setShowFindSearch(showFindSearch ? false : true)
          break;
        case 'F5':
          event.preventDefault();
          fetchPeople()
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    fetchPeople();

    axios.post("https://rt-rl-api.aajkaa.in/ddlist/getcolumndata", { columnName: "id_doc" }, {
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then((response) => {
      if (response.data[0]['id_doc'] == null) {
        setEntityIdList([])
        return
      }
      setEntityIdList(response.data[0]['id_doc'].split(','))
    });

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map((tooltipTriggerEl) => new window.bootstrap.Tooltip(tooltipTriggerEl));

    // Cleanup function to destroy tooltips when the component unmounts
    return () => {
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
        if (tooltip) {
          tooltip.dispose();
        }
      });
    };
  }, []);

  const fetchPeople = async () => {
    try {
      setProgress(10)
      const response = await axios.get('https://rt-rl-api.aajkaa.in/vehiclelist/', {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });

      const allgoodslistname = await axios.get('https://rt-rl-api.aajkaa.in/goodslist/getgoodslistsnameonly/', {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });

      const allvendorsname = await axios.get('https://rt-rl-api.aajkaa.in/vendorlist/getvendornameonly/', {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });

      const allonwersname = await axios.get('https://rt-rl-api.aajkaa.in/ownerlist/getownernameonly/', {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });

      const alldriversname = await axios.get('https://rt-rl-api.aajkaa.in/driverlist/getdrivernameonly/', {
        headers: { accessToken: localStorage.getItem("accessToken") }
      });

      setPeople(response.data);
      setAllGoodsListName(allgoodslistname.data);
      setAllVendorsName(allvendorsname.data);
      setAllOnwersname(allonwersname.data);
      setAllDriversName(alldriversname.data);

      setLoading(false)
      setProgress(100)
    } catch (error) {
      console.error('Error fetching people', error);
    }
  };

  const handleAddPerson = async (e) => {
    e.preventDefault()
    let person = { vehicle_no, model, capacity, regions, owner_name, vendor_name, driver_name, goods_types, vehicle_id_doc, vehicle_id_doc_no, vehicle_id_doc_validity, createdby: authState.username };

    if (editIndex !== null) {
      try {
        person = { vehicle_no, model, capacity, regions, owner_name, vendor_name, driver_name, goods_types, vehicle_id_doc, vehicle_id_doc_no, vehicle_id_doc_validity, updatedby: authState.username };
        await axios.put(`https://rt-rl-api.aajkaa.in/vehiclelist/${people[editIndex].id}`, person, {
          headers: { accessToken: localStorage.getItem("accessToken") },
        });
        setDisableAdd(false)
        resetFormAndReloadPeople();
      } catch (error) {
        console.error('Error updating person', error);
      }
    } else {
      try {
        await axios.post('https://rt-rl-api.aajkaa.in/vehiclelist/', person, {
          headers: { accessToken: localStorage.getItem("accessToken") },
        }).then((res) => {
          toast.success('Added successfully...', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          resetFormAndReloadPeople();
          setShowAdd(false)
          setDisableUpdate(false)
        });
      } catch (error) {
        console.error('Error adding person', error);
      }
    }
  };

  const resetFormAndReloadPeople = async () => {
    setVehicleNo("")
    setModel("")
    setCapacity("")
    setRegions("")
    setOwnerName("")
    setVendorName("")
    setDriverName("")
    setGoodsTypes("")
    setVehicleIdDoc("")
    setVehicleIdDocNo("")
    setVehicleIdDocValidity("")

    setShowAdd(false);
    setShowFindSearch(false);
    setEditIndex(null);

    await fetchPeople();
  };

  const handleEditPerson = (index) => {
    const personToEdit = people[index];
    console.log(personToEdit)
    setEditIndex(index);

    setVehicleNo(personToEdit.vehicle_no)
    setModel(personToEdit.model)
    setCapacity(personToEdit.capacity)
    setRegions(personToEdit.regions)
    setOwnerName(personToEdit.owner_name)
    setVendorName(personToEdit.vendor_name)
    setDriverName(personToEdit.driver_name)
    setGoodsTypes(personToEdit.goods_types)
    setVehicleIdDoc(personToEdit.vehicle_id_doc)
    setVehicleIdDocNo(personToEdit.vehicle_id_doc_no)
    setVehicleIdDocValidity(personToEdit.vehicle_id_doc_validity)

  };

  const handleCancelBtn = () => {
    setDisableAdd(false)
    setEditIndex(null);

    setVehicleNo("")
    setModel("")
    setCapacity("")
    setRegions("")
    setOwnerName("")
    setVendorName("")
    setDriverName("")
    setGoodsTypes("")
    setVehicleIdDoc("")
    setVehicleIdDocNo("")
    setVehicleIdDocValidity("")
  };

  const handleDeletePerson = async (index) => {
    try {
      await axios.delete(`https://rt-rl-api.aajkaa.in/vehiclelist/${people[index].id}`, {
        headers: { accessToken: localStorage.getItem("accessToken") },
      });
      fetchPeople();
    } catch (error) {
      console.error('Error deleting person', error);
    }
  };

  const handleDragStart = (e, position) => {
    e.dataTransfer.setData('text/plain', position);
  };

  const handleDrop = (e, targetPosition) => {
    e.preventDefault();
    const sourcePosition = e.dataTransfer.getData('text/plain');
    const newOrder = [...columnOrder];
    const [removedItem] = newOrder.splice(sourcePosition, 1);
    newOrder.splice(targetPosition, 0, removedItem);

    setColumnOrder(newOrder);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const columnType = {
    'vehicle_no': 'string',
    'model': 'string',
    'model': 'string',
    'regions': 'string',
    'owner_name': 'string',
    'vendor_name': 'string',
    'driver_name': 'string',
    'goods_types': 'string',
    'vehicle_id_doc': 'select',
    'vehicle_id_doc_no': 'string',
    'vehicle_id_doc_validity': 'date',
  }

  const [searchColumn, setSearchColumn] = useState("vehicle_no")
  const [searchSign, setSearchSign] = useState("contains")
  const [searchValue, setSearchValue] = useState("")
  const [signFromColType, setSignFromColType] = useState(false)


  const setSearchColType = (newValue) => {
    setSearchColumn(newValue);
    if (columnType[newValue] === "number") {
      setSignFromColType(true);
      setSearchSign("=")
    }

    if (columnType[newValue] === "string") {
      setSignFromColType(false);
      setSearchSign("contains")
    }
  };


  const filterSearch = (e) => {
    e.preventDefault();
    console.log(searchColumn, searchSign, searchValue)
    axios.post('https://rt-rl-api.aajkaa.in/vehiclelist/search', {
      col: searchColumn,
      sign: searchSign,
      value: searchValue
    }, {
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then((response) => {
      setPeople(response.data)
    })
  }

  const sortPeople = (column, order) => {
    console.log(column, order)
    axios.post('https://rt-rl-api.aajkaa.in/vehiclelist/sort', {
      col: column,
      order: order,
    }, {
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then((response) => {
      setPeople(response.data)
    })
  };

  const [sortColName, setSortColName] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const handleSort = (e, column) => {
    e.preventDefault();

    setSortColName(prevSortColName => {
      if (column !== prevSortColName || sortOrder === "") {
        setSortOrder("ASC");
      } else if (column === prevSortColName && sortOrder === "ASC") {
        setSortOrder("DESC");
      } else if (sortOrder === "DESC") {
        setSortOrder("ASC");
      }
      return column;
    });

  };

  useEffect(() => {
    if (sortColName != "" && sortOrder != "") {
      sortPeople(sortColName, sortOrder)
    }
    console.log(sortColName, sortOrder);
  }, [sortColName, sortOrder]);


  const [progress, setProgress] = useState(0)

  const setters = {
    vehicle_no: setVehicleNo,
    model: setModel,
    capacity: setCapacity,
    regions: setRegions,
    owner_name: setOwnerName,
    vendor_name: setVendorName,
    driver_name: setDriverName,
    goods_types: setGoodsTypes,
    vehicle_id_doc: setVehicleIdDoc,
    vehicle_id_doc_no: setVehicleIdDocNo,
    vehicle_id_doc_validity: setVehicleIdDocValidity,
  };

  const settersvariable = {
    vehicle_no: vehicle_no,
    model: model,
    capacity: capacity,
    regions: regions,
    owner_name: owner_name,
    vendor_name: vendor_name,
    driver_name: driver_name,
    goods_types: goods_types,
    vehicle_id_doc: vehicle_id_doc,
    vehicle_id_doc_no: vehicle_id_doc_no,
    vehicle_id_doc_validity: vehicle_id_doc_validity,
  };


  const setterscolumns = {
    vehicle_no: "vehicle No",
    model: "model",
    capacity: "capacity",
    regions: "regions",
    owner_name: "owner Name",
    vendor_name: "Vendor Name",
    driver_name: "driver Name",
    goods_types: "goods Types",
    vehicle_id_doc: "vehicle Id Doc",
    vehicle_id_doc_no: "vehicle Id Doc No",
    vehicle_id_doc_validity: "vehicle Id Doc Validity"
  };


  const settersselections = {
    vehicle_id_doc:
      <select style={{ width: "100%", height: "29.62px" }} value={vehicle_id_doc} onChange={(e) => setVehicleIdDoc(e.target.value)}>
        <option value="" selected disabled>ID Document</option>
        {entityIdList.map((option, index) => (
          <option key={index} value={option}>{option}</option>
        ))}
      </select>
    ,
    goods_types:
      <>
        <input value={goods_types} onChange={(e) => setGoodsTypes(e.target.value)} autoComplete='off' list="allgoodslistsname" placeholder='Goods Types' />
        <datalist id="allgoodslistsname">
          {allGoodsListName.map((val, index) => {
            return (
              <option key={index} value={val.itemname} />
            )
          })}
        </datalist>
      </>
    ,
    vendor_name:
      <>
        <input value={vendor_name} onChange={(e) => setVendorName(e.target.value)} autoComplete='off' list="allvendorsname" placeholder='Vendor Name' />
        <datalist id="allvendorsname">
          {allVendorsName.map((val, index) => {
            return (
              <option key={index} value={val.name} />
            )
          })}
        </datalist>
      </>
    ,
    owner_name:
      <>
        <input value={owner_name} onChange={(e) => setOwnerName(e.target.value)} autoComplete='off' list="allownersname" placeholder='Owner Name' />
        <datalist id="allownersname">
          {allOnwersname.map((val, index) => {
            return (
              <option key={index} value={val.owner_name} />
            )
          })}
        </datalist>
      </>
    ,
    driver_name:
      <>
        <input value={driver_name} onChange={(e) => setDriverName(e.target.value)} autoComplete='off' list="alldriversname" placeholder='Driver Name' />
        <datalist id="alldriversname">
          {allDriversName.map((val, index) => {
            return (
              <option key={index} value={val.drivername} />
            )
          })}
        </datalist>
      </>
  };


  const showOneHideAll = () => {
    setShowAdd(false)
    setShowFindSearch(false)
    setDisableUpdate(false)
  }


  return (
    <div className=''>
      <ToastContainer />
      <LoadingBar height={5} color='#f11946' progress={progress} />
      <button className='btn btn-primary me-2' disabled={disableAdd} onClick={() => { showOneHideAll(); setShowAdd(showAdd ? false : true); setDisableUpdate(showAdd ? false : true); }}><i className="fa-solid fa-plus me-2"></i>Add New User (F2)</button>
      <button className='btn btn-success me-2' onClick={() => { showOneHideAll(); setShowFindSearch(showFindSearch ? false : true) }}> <i className="fa-solid fa-magnifying-glass me-2"></i>Find / Search (F3)</button>
      <button className='btn btn-warning me-2' onClick={() => fetchPeople()}><i className="fa-solid fa-eraser me-2"></i>Clear all find and sort (F5)</button>

      {
        showAdd && (
          <div className='mt-2' style={{ border: '1px solid black', padding: "10px", width: "fit-content" }}>
            <form className='d-flex flex-wrap gap-2' onSubmit={(e) => handleAddPerson(e)}>
              <input type="text" placeholder='Vehicle No' value={vehicle_no} onChange={(e) => setVehicleNo(e.target.value)} />
              <input type="text" placeholder='Model' value={model} onChange={(e) => setModel(e.target.value)} />
              <input type="text" placeholder='Capacity' value={capacity} onChange={(e) => setCapacity(e.target.value)} />
              <input type="text" placeholder='Regions' value={regions} onChange={(e) => setRegions(e.target.value)} />
              <input value={owner_name} onChange={(e) => setOwnerName(e.target.value)} autoComplete='off' list="allownersname" placeholder='Owner Name' />
              <datalist id="allownersname">
                {allOnwersname.map((val, index) => {
                  return (
                    <option key={index} value={val.owner_name} />
                  )
                })}
              </datalist>
              <input value={vendor_name} onChange={(e) => setVendorName(e.target.value)} autoComplete='off' list="allvendorsname" placeholder='Vendor Name' />
              <datalist id="allvendorsname">
                {allVendorsName.map((val, index) => {
                  return (
                    <option key={index} value={val.name} />
                  )
                })}
              </datalist>
              <input value={driver_name} onChange={(e) => setDriverName(e.target.value)} autoComplete='off' list="alldriversname" placeholder='Driver Name' />
              <datalist id="alldriversname">
                {allDriversName.map((val, index) => {
                  return (
                    <option key={index} value={val.drivername} />
                  )
                })}
              </datalist>
              {/* <input value={goods_types} onChange={(e) => setGoodsTypes(e.target.value)} autoComplete='off' list="allgoodslistsname" placeholder='Goods Types' /> */}
              <datalist id="allgoodslistsname">
                {allGoodsListName.map((val, index) => {
                  return (
                    <option key={index} value={val.itemname} />
                  )
                })}
              </datalist>
              <select
                onChange={(e) => setGoodsTypes([...e.target.selectedOptions].map(option => option.value).join(', ')) }
                multiple
                style={{ width: '300px' }}
              >
                <option value="" disabled>
                  Goods Types
                </option>
                {allGoodsListName.map((val, index) => (
                  <option key={index} value={val.itemname}>
                    {val.itemname}
                  </option>
                ))}
              </select>

              <select value={vehicle_id_doc} onChange={(e) => setVehicleIdDoc(e.target.value)}>
                <option value="" disabled>ID Document</option>
                {entityIdList.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
              <input type="text" placeholder='Vehicle ID Doc No' value={vehicle_id_doc_no} onChange={(e) => setVehicleIdDocNo(e.target.value)} />
              <input type="date" placeholder='Vehicle ID Doc Validity' value={vehicle_id_doc_validity} onChange={(e) => setVehicleIdDocValidity(e.target.value)} />
              <button className='btn btn-sm btn-primary' type='submit'>{editIndex !== null ? 'Update' : 'Add'}</button>
            </form>
          </div>
        )
      }

      {
        showFindSearch && (
          <form onSubmit={(e) => filterSearch(e)} className='mt-2' style={{ border: '1px solid black', padding: "10px", width: "fit-content" }}>
            <select onChange={(e) => { setSearchColType(e.target.value); }} className='me-2' style={{ height: "30px", width: "150px" }}>
              {columnOrder.map((column, index) => (
                column[1] == 'checkbox' ? <></> :
                  <option value={column[0]}>{column[0]}</option>
              ))}
            </select>
            <select onChange={(e) => { setSearchSign(e.target.value) }} required className='me-2' style={{ height: "30px", width: "150px" }}>
              {signFromColType == true ?
                <>
                  <option value="="> = (Equal)</option>
                  <option value="!="> != (Not Equal)</option>
                  <option value="<="> {'<='} (Less Than or Equal)</option>
                  <option value=">=">{'>='} (Greater Than or Equal)</option>
                  <option value="<"> {'<'} (Less Than)</option>
                  <option value=">"> {'>'} (Greater Than)</option>
                </>
                :
                <>
                  <option value="contains">Contains</option>
                  <option value="doesnotcontains">Does not contains</option>
                  <option value="beginwith">Begin with</option>
                </>
              }
            </select>

            <input type="text" onChange={(e) => { setSearchValue(e.target.value) }} required className='me-2' style={{ height: "30px", width: "150px" }} />
            <button type='submit' className='btn btn-sm btn-success'>Search</button>
          </form>
        )
      }
      <div className='mt-2' style={{ width: '100%', maxHeight: "70vh", overflow: 'auto', padding: "5px 150px 10px 10px", border: "1px solid black" }}>
        <table className='' style={{ width: '100%', tableLayout: 'fixed' }}>
          <thead>
            <tr>
              {columnOrder.map((column, index) => (
                <th
                  key={column}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDrop={(e) => handleDrop(e, index)}
                  onDragOver={handleDragOver}
                  onClick={(e) => { handleSort(e, column[0]) }}
                  data-bs-toggle="tooltip" data-bs-placement="top" title={setterscolumns[column[0]]}
                  style={{ padding: "0 10px", width: "150px", textAlign: "center", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                  <i className="fa-solid fa-sort me-2"></i>{setterscolumns[column[0]]}
                </th>
              ))}
              <th style={{ paddingLeft: "38px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columnOrder.length + 1}>
                  <Loading />
                </td>
              </tr>
            ) : (
              people.map((person, index) => (
                <tr key={person.id}>
                  {columnOrder.map((column) => (
                    <td
                      key={`${person.id}-${column}`}
                      style={{ textAlign: "center", maxWidth: '150px', border: "1px solid black", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                      {editIndex === index ? (
                        column[1] === 'select' ? (
                          settersselections[column[0]]
                        ) : column[1] === 'text' || column[1] === 'date' ? (
                          <input
                            type={column[1]}
                            value={settersvariable[column[0]]}
                            onChange={(e) => setters[column[0]](e.target.value)}
                            style={{ width: '100%' }}
                          />
                        ) : (<></>)
                      ) : (
                        column[0] != 'wan' ? (
                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={String(person[column[0]])}>{String(person[column[0]])}</span>
                        ) : (
                          (person['wanverified'] == true ? <>{String(person[column[0]])} <i title="Verified" className="text-success ms-2 fa-solid fa-square-check"></i></> : <>{String(person[column[0]])}<i title='Unverified' className="text-warning ms-2 fa-solid fa-triangle-exclamation"></i></>)
                        )
                      )}
                    </td>
                  ))}
                  <td>
                    {editIndex === index ? (
                      <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-secondary ms-2' onClick={handleCancelBtn}>Cancel</button>
                        <button className='btn btn-sm btn-success  ms-2' onClick={handleAddPerson}>Save</button>
                      </div>
                    ) : (
                      <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-warning ms-2' disabled={disableUpdate} onClick={() => { setDisableAdd(true); handleEditPerson(index) }}>Edit</button>
                        <button className='btn btn-sm btn-danger ms-2' onClick={() => handleDeletePerson(index)} style={{ marginRight: "50px" }}>Delete</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div >
  )
}

export default UserList